import { SET_SUBSCRIPTION, CLEAR_SUBSCRIPTION } from './subscriptionTypes';

export const setSubscription = (subscription) => ({
    type: SET_SUBSCRIPTION,
    payload: subscription,
});

export const clearSubscription = () => ({
    type: CLEAR_SUBSCRIPTION,
});
